import { Link } from "react-router-dom";
import Icon from "../../components/icons";
import PageHero from "../../components/PageHero";
import Reveal from "../../components/Reveal";
import SiteLayout from "../../components/SiteLayout";

const DashboardComponent = () => (
  <SiteLayout>
    <PageHero
      compact
      eyebrow="Client workspace preview"
      title={<>Project visibility, <span>without the noise.</span></>}
      description="A focused view of active work, upcoming decisions, and delivery health."
    />
    <section className="workspace-section">
      <div className="site-container workspace-shell">
        <div className="workspace-head">
          <div><span className="workspace-status">On track</span><h2>Customer platform</h2><p>Release 02 · Product delivery</p></div>
          <Link className="button button-dark-outline" to="/">Return to website</Link>
        </div>
        <div className="workspace-metrics">
          <article><span>Current focus</span><strong>Customer onboarding</strong><small>3 work items in progress</small></article>
          <article><span>Next checkpoint</span><strong>Thursday</strong><small>Prototype review</small></article>
          <article><span>Release health</span><strong className="metric-good">Healthy</strong><small>All critical paths passing</small></article>
        </div>
        <div className="workspace-grid">
          <Reveal className="workspace-panel">
            <div className="workspace-panel-head"><h3>Delivery map</h3><span>September</span></div>
            <div className="delivery-list">
              {[["Complete", "Product framing", "Decisions documented"], ["Active", "Experience design", "Prototype in review"], ["Active", "Core engineering", "Onboarding flow"], ["Next", "Launch readiness", "Planned"]].map(([state, title, note]) => (
                <div key={title} className={`delivery-item state-${state.toLowerCase()}`}><i/><div><strong>{title}</strong><span>{note}</span></div><em>{state}</em></div>
              ))}
            </div>
          </Reveal>
          <Reveal delay={100} className="workspace-panel decision-panel">
            <div className="workspace-panel-head"><h3>Decisions needed</h3><span>2 open</span></div>
            <div className="decision-card"><span>Due Thursday</span><h4>Choose the first-time user path</h4><p>Confirm whether teams can invite collaborators during setup.</p><button type="button">Review context <Icon name="arrow" /></button></div>
            <div className="decision-card decision-muted"><span>Upcoming</span><h4>Notification preferences</h4><p>Review after onboarding is approved.</p></div>
          </Reveal>
        </div>
      </div>
    </section>
  </SiteLayout>
);

export default DashboardComponent;
